// extracted by mini-css-extract-plugin
export default {"week":"index_week__72F53","current":"index_current__sDJrq","day":"index_day__6TuV0","date":"index_date__1u2sH","active":"index_active__4i7qC"};